<template>
  <div class="gift-note">
    <button
      aria-label="toggle gift notes"
      class="gift-note--toggle"
      @click="toggleGiftForm"
    >
      <div class="gift-note--label">
        <span class="gift-note--text" v-text="toggleText"></span>
      </div>

      <div class="gift-note--right">
        <div
          class="gift-note--remove"
          v-show="note"
          v-on:click.stop.prevent="clearNote"
        >
          <svg-trash></svg-trash>
        </div>
        <div class="gift-note--price" v-show="!note">Free</div>
      </div>
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "cart-gift-note-toggle",
  computed: {
    ...mapGetters({
      note: "cart/note",
    }),
    toggleText() {
      return this.note ? "Gift note added!" : "+ Add a gift note";
    },
  },
  methods: {
    ...mapActions({
      clearNote: "cart/clearNote",
      toggleGiftForm: "cart/toggleGiftForm",
    }),
  },
};
</script>
